<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div class="ld-panel-title">
		<h2 class="back-btn">日志管理</h2>
	</div>
	<div class="ld-panel-main">
		<el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
			<el-tab-pane label="操作日志" name="0">
				<div class="input-select">
					<el-input
					  v-model="keywordsOpe"
					  placeholder="请输入搜索关键词..."
					  class="input-with-select"
					  clearable 
					  @clear="handleEmpty"
					  style="width: 400px;"
					>
					  <template #prepend>
						<el-select v-model="daysOpe" placeholder="操作时间" style="width: 100px">
						  <el-option label="操作时间" value="0" />
						  <el-option label="当天操作" value="1" />
						  <el-option label="7天内操作" value="7" />
						  <el-option label="15天操作" value="15" />
						  <el-option label="30天操作" value="30" />
						</el-select>
					  </template>
					  <template #append>
						<el-button @click="searchClick"></el-button>
					  </template>
					</el-input>
				</div>
				<tableList :loading="loadingOpe" :tableCol="tableColOpe" :tableData="tableDataOpe" :pagination="paginationOpe" :paginationTotal="paginationTotalOpe" @handleSizeChange="handleSizeChangeOpe" @handleCurrentChange="handleCurrentChangeOpe"></tableList>
			</el-tab-pane>
			<el-tab-pane label="登录日志" name="1">
				<div style=" margin-bottom: 20px;">
					<el-select v-model="daysLogin" placeholder="登录时间" style="width: 160px" @change="selectLogin">
					  <el-option label="登录时间" value="0" />
					  <el-option label="当天登录" value="1" />
					  <el-option label="7天内登录" value="7" />
					  <el-option label="15天内登录" value="15" />
					  <el-option label="30天内登录" value="30" />
					</el-select>
				</div>
				<tableList :loading="loadingLogin" :tableCol="tableColLogin" :tableData="tableDataLogin" :pagination="paginationLogin" :paginationTotal="paginationTotalLogin" @handleSizeChange="handleSizeChangeLogin" @handleCurrentChange="handleCurrentChangeLogin"></tableList>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import tableList from '../../components/tableList.vue';
	import sideNav from '../../components/sideNav.vue';
	import { getOperateLog,getLoginLog } from '@/api/account';
	import { Search } from '@element-plus/icons-vue';
	
	const pageTitle = 'account';
	const activeName = ref('0');
	const daysLogin = ref('0');
	const daysOpe = ref('0');
	const keywordsOpe = ref('');
	const paginationOpe = reactive({page: 1,size: 15});
	const paginationTotalOpe = ref('');
	const loadingOpe = ref();
	const paginationLogin = reactive({page: 1,size: 15});
	const paginationTotalLogin = ref('');
	const loadingLogin = ref();
	const tableDataOpe = ref();
	const tableDataLogin = ref();
	const tableColOpe = reactive([
	    {
			prop: 'id',
			label: '编号',
			width: '100'
		},
		{
			prop: 'info',
			label: '操作内容'
		},
		{
			prop: 'addTime',
			label: '操作时间',
			width: '200'
		},
		{
			prop: 'ipAddress',
			label: '操作IP地址',
			width: '160'
		},
		{
			prop: 'ipArea',
			label: 'IP所属区域',
			width: '220'
		}
	]);
	const tableColLogin = reactive([
	    {
			prop: 'id',
			label: '编号',
			width: '100'
		},
		{
			prop: 'loginTime',
			label: '登录时间'
		},
		{
			prop: 'type',
			label: '登录区域'
		},
		{
			prop: 'ipAddress',
			label: '登录IP地址'
		},
		{
			prop: 'ipArea',
			label: 'IP所属区域'
		},
		{
			prop: 'loginType',
			label: '登录方式'
		}
	]);
	const fetchOpeF = () => {
		const param = {
			'page':paginationOpe.page,
			'pageSize':paginationOpe.size,
			'keywords':keywordsOpe.value,
			'days':parseInt(daysOpe.value)
		}
		getOperateLog(param).then((res) => {
			paginationTotalOpe.value = res.data.total;
			tableDataOpe.value = res.data.list;
			loadingOpe.value = false;
		})
	};
	const fetchLoginF = () => {
		const param = {
			'page':paginationLogin.page,
			'pageSize':paginationLogin.size,
			'days':parseInt(daysLogin.value)
		}
		getLoginLog(param).then((res) => {
			paginationTotalLogin.value = res.data.total;
			tableDataLogin.value = res.data.list;
			loadingLogin.value = false;
		})
	};
	const handleCurrentChangeOpe = (e) => {
		paginationOpe.page = e;
		fetchOpeF()
	}
	const handleSizeChangeOpe = (e) => {
		paginationOpe.size = e;
		fetchOpeF()
	}
	const handleCurrentChangeLogin = (e) => {
		paginationLogin.page = e;
		fetchLoginF()
	}
	const handleSizeChangeLogin = (e) => {
		paginationLogin.size = e;
		fetchLoginF()
	}
	const searchClick = () => {
		fetchOpeF();
	};
	const handleEmpty = () => {
		fetchOpeF();
	};
	const selectLogin = (e) => {
		daysLogin.value = e;
		fetchLoginF();
	};
	
	onMounted(() => {
		fetchOpeF();
		fetchLoginF();
	});
</script>

<style>
</style>